import { StaticLink } from '@silvertours/common-landingpages-view';
import { Runtime } from '@silvertours/front-entities';

const CH_MAIN_LINKS: StaticLink[] = [
  {
    type: 'main',
    href: 'https://support.billiger-mietwagen.de/hc/de',
    text: 'Kundenservice',
    target: '_blank',
    masked: false,
    title: '',
    weight: 0,
    highlightText: '',
  },
  {
    type: 'main',
    href: 'https://www.billiger-mietwagen.ch/',
    text: 'Mietwagen',
    target: '_self',
    masked: false,
    title: '',
    weight: 6,
    highlightText: '',
  },
];

const CH_LEGAL_LINKS: StaticLink[] = [
  {
    type: 'legal',
    href: '/rechtliches/datenschutz.html',
    text: 'Datenschutz',
    target: '_blank',
    masked: false,
    title: '',
    weight: 1,
    highlightText: '',
  },
  {
    type: 'legal',
    href: '#uc-central-modal-show',
    text: 'Cookies',
    target: '_self',
    masked: false,
    title: '',
    weight: 2,
    highlightText: '',
  },
  {
    type: 'legal',
    href: '/rechtliches/allgemeine-geschaeftsbedingungen.html',
    text: 'AGB',
    target: '_blank',
    masked: false,
    title: '',
    weight: 3,
    highlightText: '',
  },
  {
    type: 'legal',
    href: '/rechtliches/impressum.html',
    text: 'Impressum',
    target: '_blank',
    masked: false,
    title: '',
    weight: 4,
    highlightText: '',
  },
];

export const useStaticLinks = () => {
  const { market } = Runtime.useLocale();
  const isSwissPage = market === 'CH';

  return {
    getHeaderLinks: (staticLinks: StaticLink[]) =>
      isSwissPage
        ? CH_MAIN_LINKS
        : staticLinks.filter(({ type }) => type === 'main'),
    getFooterLinks: (staticLinks: StaticLink[]) =>
      isSwissPage
        ? []
        : staticLinks.filter(
            ({ type, text, href }) =>
              type === 'footer' && text !== '' && href !== '',
          ),
    getLegalLinks: (staticLinks: StaticLink[]) =>
      isSwissPage
        ? CH_LEGAL_LINKS
        : staticLinks.filter(
            ({ type, text, href }) =>
              type === 'legal' && text !== '' && href !== '',
          ),
    getSocialMediaLinks: (staticLinks: StaticLink[]) =>
      staticLinks.filter(
        ({ type, text, href }) =>
          type === 'socialMedia' && text !== '' && href !== '',
      ),
    getAppLinks: (staticLinks: StaticLink[]) =>
      staticLinks.filter(
        ({ type, text, href }) => type === 'app' && text !== '' && href !== '',
      ),
  };
};
